import {getTimeOfDay, safeParse} from "../utils/date-formatters.mjs";
import { isSchoolBooking } from "../../services/performance.js";

let performanceData;

export default async function getPerformances() {
    if (performanceData) {
        return performanceData;
    }

    try {
        performanceData = fetch('/api/event-instances.json')
            .then(res => res.json())
            .then(data => processPerformances(data.docs));

        return performanceData;
    } catch (error) {
        console.error('Failed to load instances:', error);

        throw error;
    }
}

function processPerformances(performances) {
    const now = new Date();

    return performances
        .map(performance => {
            const startDate = safeParse(performance.startDateLocalAsUTC);

            performance.startDate = startDate;
            performance.timeOfDay = getTimeOfDay(startDate);

            if (AppConfig.boDomain) {
                performance.bookButton = {
                    title: 'Get Tickets',
                    link: `${AppConfig.boDomain.replace(/^\/|\/$/g, '')}/booking/production/${performance.tessitura.performanceId}`
                };
            } else if (AppConfig.tnewDomain) {
                performance.bookButton = {
                    title: 'Get Tickets',
                    link: (
                        isSchoolBooking(performance) ?
                        `${AppConfig.tnewDomain.replace(/^\/|\/$/g, '')}/c/schoolbooking?perfNo=${performance.tessitura.performanceId}` :
                        `${AppConfig.tnewDomain.replace(/^\/|\/$/g, '')}/${performance.tessitura.productionSeasonId}/${performance.tessitura.performanceId}`
                    )
                };
            } else {
                performance.bookButton = null;
            }

            performance.isSoldOut = parseInt(performance.tessitura?.availability || 0, 10) === 0 || performance.bookingStatus === 'soldOut';

            // Handles overrides on the Basker instances
            if (performance.event.booking?.bookingLinkURL) {
                performance.bookButton = performance.bookButton || {};
                performance.bookButton.link = performance.event.booking?.bookingLinkURL;
            }
            if (performance.event.booking?.bookingLinkLabel && performance.bookButton) {
                performance.bookButton.title = performance.event.booking?.bookingLinkLabel;
            }

            performance.performanceType = isSchoolBooking(performance) ?
                'school' :
                'public';

            performance.accessibility = [];

            if (performance.tessitura?.keywords?.length) {
                performance.accessibility = [].concat(
                    performance.accessibility,
                    performance.tessitura?.keywords?.filter(kw => kw.Category.Id === 10)    // "Ancillary Event" Category
                );
            }

            if (performance.tessitura?.keywords?.length) {
                performance.accessibility = [].concat(
                    performance.accessibility,
                    performance.tessitura?.keywords?.filter(kw => kw.Category.Id === 14)    // "Accessiblity Programs" Category
                );
            }

            performance.accessibility = performance.accessibility.map(kw => kw.Description.replace(/\s(Public|School)/, ''));

            return performance;
        })
        .filter(performance => performance.startDate >= now);
}
